import { httpCreate } from './http';

const http = httpCreate('/srv/sms');

export const sms = {
	/**
	 * @param { Number } data.mobile 手机号
	 * @param { Numebr } data.areaCode 区域号
	 */
	smsCode(data) {
		return http.post('/smsCode', data);
	},
	// 校验需不需要发送验证码(红包雨和有奖竞猜余额抵扣前)
	checkSend(params) {
		return http.get('/offset/checkSend', { params });
	},
	offsetSmsCode(data) {
		return http.post('/offset/smsCode', data);
	},
};
